import { API_URL } from '../../../app-config/constants';
import type { FeatureCategory } from '../../../types/Feature';
import type { Setting } from '../../react/features/Admin/FeatureSelection/types';
import { get, post } from '../request';

const FEATURE_SELECTION_SETTINGS_URL = `${API_URL}/admin/feature-selection/settings`;

export function getFeatureSelectionPage() {
    return get<Setting[]>(FEATURE_SELECTION_SETTINGS_URL);
}

export function getFeatureSelectionByCategory(featureCategory: FeatureCategory) {
    return get<Setting[]>(`${FEATURE_SELECTION_SETTINGS_URL}/${featureCategory}`);
}

postFeatureSelectionPage.operation = 'COMMAND';
export function postFeatureSelectionPage(request: Setting[]) {
    return post(FEATURE_SELECTION_SETTINGS_URL, { postData: request });
}
